<template>
    <div class="relative">
        <label class="flex flex-col group items-center text-center has-[:disabled]:opacity-25 has-[:disabled]:pointer-events-none">
            <input
                type="radio"
                :name="name"
                :value="option.attributes.value"
                :disabled="disabled"
                :checked="checked"
                @change="emit('change')"
                class="peer sr-only"
            />
            <span class="relative border border-gray-275 p-3 rounded-full w-full max-w-[144px] group-hover:border-gray-800 peer-checked:bg-gray-425 peer-checked:border-gray-800 dark:border-gray dark:group-hover:border-gray-125 dark:peer-checked:bg-gray-675 dark:peer-checked:border-gray-125">
                <img :src="imageUrl" loading="lazy" class="aspect-square w-full rounded-full" onerror="imageError = true" v-if="!imageError" />
                <BaseSvg name="QuestionMarkCircle" v-if="imageError" />
                <button class="absolute bg-gray flex group items-center justify-center left- rounded-full size-6 right-2 translate-x-1/4 top-0 hover:bg-gray-800 dark:bg-gray-275 dark:hover:bg-white" @click="emit('preview')" v-if="option.attributes.description || option.attributes.image">
                    <BaseSvg name="Preview" class="fill-white size-4 dark:fill-gray-800 dark:group-hover:fill-gray-800" aria-hidden="true" />
                    <span class="sr-only">View {{ option.attributes.value }} detail</span>
                </button>
            </span>
            <span class="max-w-full text-gray text-sm truncate peer-checked:text-gray-800 dark:text-gray-425 dark:peer-checked:text-white">
                <b v-if="option.attributes.value" class="inline-block mr-1 text-gray-800 dark:text-white">{{ option.attributes.value }}</b>
                <span v-if="option.attributes.label !== option.attributes.value">{{ option.attributes.label }}</span>
            </span>
        </label>
    </div>
</template>
<script setup>
import { BaseSvg } from "@/Components";
import { computed, ref } from "vue";
import { useAssetTransforms } from "@/Composables";

const emit = defineEmits(['preview', 'change'])
const { assetUrl, marketingAssetUrl } = useAssetTransforms();

const { name, option } = defineProps({
    name: {
        type: String,
        required: true,
    },
    option: {
        type: Object,
        required: true,
    },
    checked: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
})

const imageError = ref(false)
const imageUrl = computed(() => {
    if (name === 'finish') {
        return marketingAssetUrl(option.attributes.label.replace('/', ''))
    }

    return assetUrl(option.attributes.image)
})
</script>
